import React, { useState } from 'react'
import { Grid, Form, Loader, Icon } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { DropDown } from '../../../commonComponents/formComponents/dropDown'
import { useSelector ,useDispatch} from 'react-redux'
import DeleteIcon from '../../../commonComponents/deleteIcon'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import { validation } from '../../util/cdsFieldPatterns';
import {addValueBuildUpTabWarnings,deleteValueBuildUpTabWarnings} from "../../actions/errorValidationActions";

function ValueBuildUpList(props) {
  const { item, deleteData, updateData, saveData } = props

 

  const id= item.id
  const currencyDropDown = useSelector((state) => state.DropDownValues.currencyTypes)
  const additionsDropDown = useSelector((state) => state.DropDownValues.additionsAndDeductionsType)
  const {declarationCat = ''} = useSelector((state) => state.Shipment)
  const currShipData = useCurrentShipmentType();
  const {isDisabled} = currShipData || {}
  const dispatch = useDispatch()

  const isFormDisabled = false
  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'valueBuildUpTab'),
    [declarationCat]
  )

  const addErrors = (level, value, fieldName) => {
    dispatch(addValueBuildUpTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteValueBuildUpTabWarnings(level, value, fieldName))
  }



  return (
    <Grid.Row>
      <Grid.Column width='5' className='divFormFeild border-bottom b-rw-0'>
        <DropDown
          id={`type${id}`}
          label='Type/Code'
          className='field-bg dropdown100'
          labelClass='text-none'
          mandatory={false}
          direction={'right'}
          disabled={isDisabled}
          isLabel={true}
          data={additionsDropDown}
          value={item.type}
          errors={getValidationError("type",item.type,true)}
          clearable
          onChange={(value) => {
            updateData(id, {"type":value?.trim() })
            saveData({id,type:value||" "})
            let err = getValidationError('type', value, 'valueBuildUpTab')
                err.length
                  ? addErrors('valueBuildUpTab', err[0], `type${id}`)
                  : deleteErrors('valueBuildUpTab', '', `type${id}`)
          }
          
          }
          
        />
      </Grid.Column>

      <Grid.Column width='5' className='divFormFeild border-bottom b-rw-0'>
        <DropDown
          id={`currency${id}`}
          label='Currency'
          className='field-bg dropdown100'
          labelClass='text-none'
          mandatory={false}
          direction={'right'}
          disabled={isDisabled}
          isLabel={true}
          data={currencyDropDown}
          value={item.currency}
          clearable
          onChange={(value) =>{
            updateData(id, {"currency":value?.trim() })
            saveData({id,currency:value||" "})
          } 
        }
       
        />
      </Grid.Column>

      <Grid.Column width='5' className='divFormFeild border-bottom'>
        <InputField
          id={`value${id}`}
          isLabel={false}
          type='text'
          value={item.value}
          errors={getValidationError("value",item.value || " ")}
          label='Value / Percentage'
          className={'field-bg'}
          clearInput={false}
          disabled={isFormDisabled}
          clearable
          onChange={(value) => updateData(id, {"value":value })}
          onBlur={(value) => {saveData({id, "value":value||" "})
          let err = getValidationError('value', value, 'valueBuildUpTab')
                err.length
                  ? addErrors('valueBuildUpTab', err[0], `value${id}`)
                  : deleteErrors('valueBuildUpTab', '', `value${id}`)
        }}
          
        

        />
      </Grid.Column>

      <Grid.Column width='1' className='icon-delete-add-info'>
        <DeleteIcon id={`deleteTypeCurrencyValue${id}`} onClick={() => deleteData(id)} disabled={isFormDisabled} />
      </Grid.Column>
    </Grid.Row>
  )
}

export default ValueBuildUpList
